import React from 'react'
import { OfferWrapper, Trivia } from 'generated/api'
import { ID } from 'lib'
import { Pending } from 'components/patterns/suspense/internals/types'
import { Skeleton, Text, View } from 'reshaped/bundle'

export const getSearchTriviaFromOffer = (offer: OfferWrapper): Array<JSX.Element> =>
	offer.trivia
		.sort((a, b) => (b.importance || 0) - (a.importance || 0))
		.map((trivia, index) => {
			return <TriviaItem key={trivia.key || `trivia-${index}`} trivia={trivia} />
		})

interface TriviaProps {
	trivia: Trivia
}

const TriviaItem: React.FC<React.PropsWithChildren<Pending<TriviaProps>>> = props => {
	let value, title, key

	if (props.pending) {
		key = ID()
		title = <Skeleton width="100px" height="24px" />
		value = <Skeleton width="80px" height={{ s: '24px', xl: '32px' }} />
	} else {
		const trivia = props.trivia
		value = trivia.value
		key = trivia.key
		title = trivia.title
	}

	return (
		<View.Item key={key} grow>
			<Text variant="body-2" color="neutral-faded">
				{title}
			</Text>
			<View direction="row">
				<Text variant="featured-2" weight="bold">
					{value}
				</Text>
			</View>
		</View.Item>
	)
}
